import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AdminRedirectWrapper({ children }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && currentUser && currentUser.isAdmin) {
      // List of user routes
      const userRoutes = ['/', '/login', '/signup', '/profile', '/bookings'];
      if (userRoutes.includes(location.pathname)) {
        navigate('/admin/dashboard', { replace: true });
      }
    }
  }, [currentUser, loading, location.pathname, navigate]);

  return children;
}
